import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import { AG_GRID_LOCALE_HU } from '@ag-grid-community/locale';
import {
  ColDef,
  ColGroupDef,
  GridApi,
  GridOptions,
  GridSizeChangedEvent,
  GridReadyEvent,
  ModuleRegistry,
  createGrid,
  ISelectCellEditorParams,
} from "ag-grid-community";
import { DataService } from 'src/app/data.service';
import { ColourCellRenderer } from '../colourCellRenderer';
import { ModalController } from '@ionic/angular';
import { TanarComponent } from '../tanar/tanar.component';

@Component({
  selector: 'app-osztaly',
  templateUrl: './osztaly.component.html',
  styleUrls: ['./osztaly.component.scss'],
})
export class OsztalyComponent implements OnInit {
  private gridApi!: GridApi<any>;
  AG_GRID_LOCALE_HU = AG_GRID_LOCALE_HU
  sajatIntezmeny;
  allomany = [];
  lista = [];
  selectedRow = [];
  compMod
  compData = {
    osztaly: {
      title: "Osztályok",
      titleIcon: "assets/icon/icons8-class-96.png",
      colDefs: [
        { field: "osztaly", headerName: "Osztály", editable: false, },
        { field: "evfolyam", headerName: "Évfolyam", editable: false, },
        { field: "ev", headerName: "Tanév", editable: false },
        { field: "of", headerName: "Osztályfőnök", editable: false, },
        { field: "szin", headerName: "Szín", editable: false, cellRenderer: ColourCellRenderer, },
      ],
      buttons: [
        { type: 'button', label: "Új osztály", icon: "assets/icon/icons8-add-96.png", disabled: false, to:'osztaly',rw:0 },
        { type: 'button', label: "Módosítás", icon: "assets/icon/icons8-edit-property-96.png", disabled: this.selectedRow.length == 0, to:'osztaly',rw:1 },
        { type: 'button', label: "Törlés", icon: "assets/icon/icons8-delete-96.png", disabled: this.selectedRow.length == 0, to:'osztaly',rw:2 },
        { type: 'break', },
        { type: 'button', label: "Órák", icon: "assets/icon/icons8-time-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Idősáv", icon: "assets/icon/icons8-schedule-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Korlátozások", icon: "assets/icon/icons8-flow-chart-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Csoportok", icon: "assets/icon/icons8-group-96.png", disabled: this.selectedRow.length == 0 },
      ]
    },
    tantargy: {
      title: "Tantárgyak",
      titleIcon: "assets/icon/icons8-open-copybook-96.png",
      colDefs: [
        { field: "name", headerName: "Név", editable: false, },
        { field: "rovid", headerName: "Rövidítés", editable: false, },
        { field: "szin", headerName: "Szín", editable: false, cellRenderer: ColourCellRenderer, },
      ],
      buttons: [
        { type: 'button', label: "Új tantárgy", icon: "assets/icon/icons8-add-96.png", disabled: false, to:'tantargy',rw:0 },
        { type: 'button', label: "Módosítás", icon: "assets/icon/icons8-edit-property-96.png", disabled: this.selectedRow.length == 0, to:'tantargy',rw:1 },
        { type: 'button', label: "Törlés", icon: "assets/icon/icons8-delete-96.png", disabled: this.selectedRow.length == 0, to:'tantargy',rw:2 },
        { type: 'break', },
        { type: 'button', label: "Órák", icon: "assets/icon/icons8-time-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Idősáv", icon: "assets/icon/icons8-schedule-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Korlátozások", icon: "assets/icon/icons8-flow-chart-96.png", disabled: this.selectedRow.length == 0 },
      ]

    },
    tanterem: {
      title: "Tantermek",
      titleIcon: "assets/icon/icons8-door-96.png",
      colDefs: [
        { field: "name", headerName: "Név", editable: false, },
        { field: "rovid", headerName: "Rövidítés", editable: false, },
        { field: "osztalyterem", headerName: "Osztályterem", editable: false },
        { field: "szin", headerName: "Szín", editable: false, cellRenderer: ColourCellRenderer, },
      ],
      buttons: [
        { type: 'button', label: "Új tanterem", icon: "assets/icon/icons8-add-96.png", disabled: false },
        { type: 'button', label: "Módosítás", icon: "assets/icon/icons8-edit-property-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Törlés", icon: "assets/icon/icons8-delete-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'break', },
        { type: 'button', label: "Órák", icon: "assets/icon/icons8-time-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Idősáv", icon: "assets/icon/icons8-schedule-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Korlátozások", icon: "assets/icon/icons8-flow-chart-96.png", disabled: this.selectedRow.length == 0 },
      ]
    },
    tanar: {
      title: "Tanárok",
      titleIcon: "assets/icon/icons8-employee-96.png",
      colDefs: [
        { field: "viselt_vez", headerName: "Vezetéknév", editable: false, },
        { field: "viselt_ker", headerName: "Keresztnév", editable: false, },
        { field: "kod", headerName: "Kód", editable: false },
        { field: "oktazon", headerName: "Azonosító", editable: false },
        { field: "szin", headerName: "Szín", editable: false, cellRenderer: ColourCellRenderer, },
      ],
      buttons: [
        { type: 'button', label: "Új tanterem", icon: "assets/icon/icons8-add-96.png", disabled: false },
        { type: 'button', label: "Módosítás", icon: "assets/icon/icons8-edit-property-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Törlés", icon: "assets/icon/icons8-delete-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'break', },
        { type: 'button', label: "Órák", icon: "assets/icon/icons8-time-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Idősáv", icon: "assets/icon/icons8-schedule-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Korlátozások", icon: "assets/icon/icons8-flow-chart-96.png", disabled: this.selectedRow.length == 0 },
      ]

    },
    allomany: {
      title: "Állomány",
      titleIcon: "assets/icon/icons8-employee-96.png",
      colDefs: [
        { field: "viselt_vez", headerName: "Vezetéknév", editable: false, },
        { field: "viselt_ker", headerName: "Keresztnév", editable: false, },
        { field: "kod", headerName: "Kód", editable: false },
        { field: "oktazon", headerName: "Azonosító", editable: false },
        { field: "szin", headerName: "Szín", editable: false, cellRenderer: ColourCellRenderer, },
      ],
      buttons: [
        { type: 'button', label: "Új tanterem", icon: "assets/icon/icons8-add-96.png", disabled: false },
        { type: 'button', label: "Módosítás", icon: "assets/icon/icons8-edit-property-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Törlés", icon: "assets/icon/icons8-delete-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'break', },
        { type: 'button', label: "Órák", icon: "assets/icon/icons8-time-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Idősáv", icon: "assets/icon/icons8-schedule-96.png", disabled: this.selectedRow.length == 0 },
        { type: 'button', label: "Korlátozások", icon: "assets/icon/icons8-flow-chart-96.png", disabled: this.selectedRow.length == 0 },
      ]

    }
  };


  rowData = [] /*= [
    { make: "Tesla", model: "Model Y", price: 64950, electric: true },
    { make: "Ford", model: "F-Series", price: 33850, electric: false },
    { make: "Toyota", model: "Corolla", price: 29600, electric: false },
  ];*/



  constructor(private modalCtrl: ModalController,private data: DataService, private ref: ChangeDetectorRef) {
  }

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny");
    this.allomany = await this.data.getAllomany().toPromise();
    //this.lista = this.allomany.map(r=>r.viselt_vez+' '+r.viselt_ker+' ('+r.oktazon+')')
    //this.compData[this.compMod].colDefs[3].cellEditorParams.values = this.lista
    //console.log(this.allomany.map(r=>r.viselt_vez+' '+r.viselt_ker+' ('+r.oktazon+')'))
  }

  onSelectionChanged(e) {
    this.selectedRow = this.gridApi.getSelectedRows()[0];
    this.compData[this.compMod].buttons.forEach(e => {
      if (e.disabled != "true" && e.disabled != "false")
        e.disabled = this.selectedRow.length == 0
    });
    this.ref.detectChanges()
  }
  async onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.allomany = [];
    this.sajatIntezmeny = [];
    this.rowData = [];

    this.sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny");
    this.allomany = await this.data.getAllomany().toPromise()
    let i = 1;
    for await (let a of this.allomany) {
      /*if(!this.allomany[a.oktazon.toString()]) {
        //this.allomany[a.oktazon.toString()]=[];
        this.allomany[a.oktazon.toString()]=a
      }*/
      i++;
      if (i == this.allomany.length && this.compMod == "osztaly") { //OSZTÁLY
        let rowData = (await this.data.getOsztaly(2024, this.sajatIntezmeny.intezmenyId).toPromise())
        rowData.forEach(f => {
          try {
            for (let a of this.allomany) {
              if (a.oktazon == f.of) {
                f.of = a.viselt_vez + " " + a.viselt_ker + ' (' + a.oktazon + ')'
                break;
              }
            }
          } catch (error) {
            f.of = "-"
          }
        });
        //console.log(rowData)
        this.rowData = rowData
        this.ref.detectChanges()
      }else if (i == this.allomany.length && this.compMod == "tanterem") { //TANTEREM
        this.rowData = (await this.data.getTanterem(2024, this.sajatIntezmeny.intezmenyId).toPromise())
        //console.log(this.rowData)
        //this.ref.detectChanges()
      }else if (i == this.allomany.length && this.compMod == "tantargy") { //TANTEREM
        this.rowData = (await this.data.getTantargy(2024, this.sajatIntezmeny.intezmenyId).toPromise())
        //console.log(this.rowData)
        //this.ref.detectChanges()
      }else if (i == this.allomany.length && this.compMod == "tanar") { //TANTEREM
        this.rowData = this.allomany.filter(a=>{
          return JSON.parse(a.intezmenyadatok).filter(d => d.kulso == 0)[0].ttf
        })
        //console.log(this.rowData)
        //this.ref.detectChanges()
      }else if (i == this.allomany.length && this.compMod == "allomany") { //TANTEREM
        this.rowData = this.allomany
        //console.log(this.rowData)
        //this.ref.detectChanges()
      }else if (i == this.allomany.length && this.compMod == "iskola") { //TANTEREM
        this.rowData = this.allomany
        //console.log(this.rowData)
        //this.ref.detectChanges()
      }
    }
    /*
        this.http
          .get<
            IOlympicData[]
          >("https://www.ag-grid.com/example-assets/olympic-winners.json")
          .subscribe((data) => (this.rowData = data));*/
  }


  onGridSizeChanged(params: GridSizeChangedEvent) {
    // get the current grids width
    var gridWidth = document.querySelector(".ag-body-viewport")!.clientWidth;
    // keep track of which columns to hide/show
    var columnsToShow = [];
    var columnsToHide = [];
    // iterate over all columns (visible or not) and work out
    // now many columns can fit (based on their minWidth)
    var totalColsWidth = 0;
    var allColumns = params.api.getColumns();
    if (allColumns && allColumns.length > 0) {
      for (var i = 0; i < allColumns.length; i++) {
        var column = allColumns[i];
        totalColsWidth += column.getMinWidth();
        if (totalColsWidth > gridWidth) {
          columnsToHide.push(column.getColId());
        } else {
          columnsToShow.push(column.getColId());
        }
      }
    }
    // show/hide columns based on current grid width
    params.api.setColumnsVisible(columnsToShow, true);
    params.api.setColumnsVisible(columnsToHide, false);
    // wait until columns stopped moving and fill out
    // any available space to ensure there are no gaps
    window.setTimeout(() => {
      params.api.sizeColumnsToFit();
    }, 10);
  }


  async openComponent(comp,rw){
    /*if(comp == "tanar") comp = TanarComponent
    if(comp == "tanterem") comp = TanteremComponent
    if(comp == "tantargy") comp = TantargyComponent
    if(comp == "osztaly") comp = OsztalyComponent*/
    
    const modal = await this.modalCtrl.create({
      component: TanarComponent,
      cssClass: 'modalom',
      componentProps:{
        compMod: comp,
        rw: rw
      }
    });
    modal.present();
  
    const { data, role } = await modal.onWillDismiss();
  
    if (role === 'confirm') {
      //this.name = data;
    }
  }

}
